module.exports = __webpack_public_path__ + "media/site/images/icons/arrow-icon-57bff5805988bd648a833374a43ffdfc.svg";